const StoreChannelType = {
  PRODUCT_PORTAL: 1,
  HARAVAN: 2,
  LIEN_VIET_POST_BANK: 3,
  MOBILE_PORTAL: 4
}
export default StoreChannelType
